import { LyneButton } from "components/Lyne/LyneButton";
import { useStandardMeetingsPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const StandardMeetingsPanelFooter: React.FC = () => {
  const i18n = useTranslations();
  const { closeStandardMeetingsPanel, handleSubmit, canSubmit } = useStandardMeetingsPanel();

  return (
    <>
      <LyneButton onClick={closeStandardMeetingsPanel} text={i18n.Actions_Close} kind="ghost" />
      <LyneButton
        className="ml-2"
        onClick={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
        disabled={!canSubmit()}
        text={i18n.StandardMeetingsPanel_Submit}
      />
    </>
  );
};
